<template>
  <aha-modal
    :title="modalTitle"
    @hide="hide()"
  >
    <div class="tab-content pb-4">
      <img src="@/assets/images/team/on-going-creat-new-team.png" />
      <p class="mt-4">
        {{ $i18nPresenter.t("Soon you'll be able to create multiple teams, but for now, you can only have one.") }}
      </p>
      <aha-button class="float-right mb-2" @click="hide">
        {{ $i18nPresenter.t("Got it!") }}
      </aha-button>
    </div>
  </aha-modal>
</template>
<script>

export default {
  data() {
    return {
      modalTitle: this.$i18nPresenter.t("Woah, we're not quite ready yet!"),
    }
  },
  computed: {

  },
  methods: {
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
<style scoped>

</style>
